export const PATH = '/configuration/session';
